import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class InventoryItemQueryCriteriaClass extends BaseCriteriaModel {
  //for hdr table
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  uom?: Optional<string> = Optional.empty();
  guid_fi_mst_item?: Optional<string> = Optional.empty();

  // for ext table
  inv_item_hdr_guid?: Optional<string> = Optional.empty();
  inv_item_line_guid?: Optional<string> = Optional.empty();
  ext_type?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  value_datetime?: Optional<string> = Optional.empty();
}

export class InventoryItemCriteriaModelQuery {
  query = '';

  constructor(InventoryItemCriteriaModel: InventoryItemQueryCriteriaClass) {

    if (!InventoryItemCriteriaModel) {
      return;
    }

    // this.query += LabelQueryCriteriaClass.convertOptionalStringToQueryParms(labelCriteriaModel.guid_parent, 'guid_parent' );
    this.query += InventoryItemCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += InventoryItemCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += InventoryItemCriteriaModel.uom.filter(x => x !== '').map(x => '&uom=' + x).orElse('');
    this.query += InventoryItemCriteriaModel.guid_fi_mst_item.filter(x => x !== '').map(x => '&guid_fi_mst_item=' + x).orElse('');

    this.query += InventoryItemCriteriaModel.inv_item_hdr_guid.filter(x => x !== '').map(x => '&inv_item_hdr_guid=' + x).orElse('');
    this.query += InventoryItemCriteriaModel.inv_item_line_guid.filter(x => x !== '').map(x => '&inv_item_line_guid=' + x).orElse('');
    this.query += InventoryItemCriteriaModel.ext_type.filter(x => x !== '').map(x => '&ext_type=' + x).orElse('');
    this.query += InventoryItemCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += InventoryItemCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += InventoryItemCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += InventoryItemCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += InventoryItemCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += InventoryItemCriteriaModel.value_datetime.filter(x => x !== '').map(x => '&value_datetime=' + x).orElse('');

    this.query += '&status=' + InventoryItemCriteriaModel.status;
    this.query += '&orderBy=' + InventoryItemCriteriaModel.orderBy;
    this.query += '&order=' + InventoryItemCriteriaModel.order;
    this.query += '&offset=' + InventoryItemCriteriaModel.offset + '&limit=' + InventoryItemCriteriaModel.limit;
  }
}


